import WaveSurfer from "wavesurfer.js";
export default function createWavesurfer(options) {
    return WaveSurfer.create(options);
}
export { WaveSurfer };
//# sourceMappingURL=createWavesurfer.js.map